import { put } from "redux-saga/effects";

import axiosGovernorate from "../../axios-governorate";
import * as actions from "../actions";
import * as actionTypes from "../actions/actionTypes";

export function* initGovernorateSaga() {
  try {
    yield put(actions.toggleIdleState());
    const response = yield axiosGovernorate.get("/api/governorate");
    console.log(JSON.parse(response.data));
    yield put(actions.setState(JSON.parse(response.data)));
    yield put(actions.toggleIdleState());
  } catch (error) {
    console.log(error.message);
  }
}

export function* getNewsSaga(action: any) {
  try {
    const response = yield axiosGovernorate.get(`/api/news/${action.newsType}/${action.day}`);

    const { news } = JSON.parse(response.data).data;
    yield put(actions.updateState({ news }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* moveCalendarSaga({
  newsType,
  year,
  month,
  direction
}: any) {
  try {
    const response = yield axiosGovernorate.post(`/api/postAction`, {
      action: "moveCalendar",
      newsType,
      year,
      month,
      direction
    });

    const { news } = JSON.parse(response.data).data;
    yield put(actions.updateNews(news));
  } catch (error) {
    console.log(error.message);
  }
}

export function* nextTurnSaga() {
  try {
    yield put(actions.toggleIdleState());

    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "nextTurn"
    });

    const { data } = JSON.parse(response.data);
    if (data.success) {
      const governorateResponse = yield axiosGovernorate.get("/api/governorate");
      yield put(actions.setState(JSON.parse(governorateResponse.data)));
      yield put(actions.toggleIdleState());
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* togglePopSaga(action: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: action.type === actionTypes.HIRE_POP ? "hirePop" : "releasePop",
      slotId: action.slotId
    });

    const { data } = JSON.parse(response.data);
    const {
      hasFinishedQuest,
      availableQuests,
      finishedQuests,
      general,
      famine,
      army,
      marketLimit,
      spellCastLimit
    } = data;

    yield put(actions.updateSlot(action.slotId, {
      pops: data.pops,
    }));
    if (general) {
      yield put(actions.updateGeneral(
        data.general,
      ));
    }
    yield put(actions.updatePopulation(data.population));
    yield put(actions.updateResources({
      resources: data.resources,
      resourceBalances: data.resourceBalances
    }));
    yield put(actions.updateState({
      famine,
      army,
      marketLimit,
      spellCastLimit
    }));
    if (hasFinishedQuest) {
      yield put(actions.updateState({
        hasFinishedQuest,
        availableQuests,
        finishedQuests
      }));
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* buildBuildingSaga(action: any) {
  // try {
  const response = yield axiosGovernorate.post("/api/postAction", {
    action: action.type === actionTypes.BUILD_BUILDING ? "buildBuilding"
      : "upgradeBuilding",
    slotId: action.slotId,
    typeId: action.buildingTypeId
  });

  const { data } = JSON.parse(response.data);
  // yield put(actions.updateSlot(action.slotId, data.slot, data.slotChains));
  yield put(actions.updatePopulation(data.population));
  yield put(actions.updateResources({
    resources: data.resources,
    resourceBalances: data.resourceBalances
  }));

  yield put(actions.closeDialog());
  if (action.type !== actionTypes.BUILD_BUILDING) {
    yield put(actions.closeTooltip("UpgradeBuilding"));
  }

  const {
    hasFinishedQuest,
    availableQuests,
    finishedQuests,
    slotChains,
    development,
    generals
  } = data;

  yield put(actions.updateDevelopment(development));

  yield put(actions.updateState({
    slotChains
  }));

  if (hasFinishedQuest) {
    yield put(actions.updateState({
      hasFinishedQuest,
      availableQuests,
      finishedQuests,
      generals
    }));
  }

  yield put(actions.closeDialog());
  yield put(actions.closeCityDialog());
  // } catch (error) {
  //   console.log(error.message);
  // }
}

export function* demolishBuildingSaga(action: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "demolishBuilding",
      slotId: action.slotId
    });

    const { data } = JSON.parse(response.data);

    const {
      resources,
      slot,
      slotChains,
      spells
    } = data;

    console.log(slotChains);
    yield put(actions.closeDialog(""));
    yield put(actions.closeCityDialog());
    if (slotChains) {
      yield put(actions.updateState({
        slotChains
      }));
    } else {
      yield put(actions.updateSlot(action.slotId, slot));
    }

    yield put(actions.updateResources({
      resources,
    }));

    if (spells) {
      yield put(actions.updateState({
        spells
      }));
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* cancelBuildingDemolitionSaga(action: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "cancelBuildingDemolition",
      slotId: action.slotId
    });

    const { data } = JSON.parse(response.data);

    yield put(actions.updateSlot(action.slotId, data.slot));

    if (data.spells) {
      yield put(actions.updateState({
        spells: data.spells
      }));
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* repairBuildingSaga(action: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "repairBuilding",
      sid: action.slotId
    });

    const { data } = JSON.parse(response.data);

    yield put(actions.updateSlot(action.slotId, data.slot));
    yield put(actions.updateResources({
      resources: data.resources,
    }));

    yield put(actions.closeDialog());
  } catch (error) {
    console.log(error.message);
  }
}

export function* questListViewedSaga() {
  try {
    yield axiosGovernorate.post("/api/postAction", {
      action: "questListViewed"
    });

    yield put(actions.updateState({
      hasFinishedQuest: false
    }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* finishQuestSaga({ questId }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "finishQuest",
      questId
    });

    const { data } = JSON.parse(response.data);
    const {
      hasFinishedQuest,
      availableQuests,
      finishedQuests,
      resources,
      resourceBalances
    } = data;

    if (hasFinishedQuest) {
      yield put(actions.updateState({
        hasFinishedQuest,
        availableQuests,
        finishedQuests
      }));
    }

    yield put(actions.updateResources({
      resources,
      resourceBalances
    }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* boostHappinessSaga({ gold }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "boostHappiness",
      gold
    });

    const { data } = JSON.parse(response.data);
    const {
      famine,
      bankruptcy,
      resources,
      resourceBalances
    } = data;

    yield put(actions.updateResources({
      resources,
      resourceBalances
    }));

    yield put(actions.updateState({
      famine,
      bankruptcy
    }));

    yield put(actions.closeTooltip());
  } catch (error) {
    console.log(error.message);
  }
}

export function* setNotificationReadSaga({ notId }: any) {
  if (notId === null || notId === undefined) {
    return;
  }

  try {
    yield axiosGovernorate.post(`/api/postAction`, {
      action: "notiRead",
      notId
    });

    yield put(actions.removeNotification(notId));
  } catch (error) {
    console.log(error.message);
  }
}

export function* setNotificationsSeenSaga() {
  try {
    yield axiosGovernorate.post(`/api/postAction`, {
      action: "notiSeen"
    });

    yield put(actions.updateNotificationsSeen());
  } catch (error) {
    console.log(error.message);
  }
}
